import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    enableNotifications: string;
    enable: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast title prompting user to enable project notifications */
            enableNotifications: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useNotificationsOptIn.enableNotifications?c=2somwcvyqdib1", defaultMessage: "Enable Notifications for this Project?" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to enable notifications */
            enable: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useNotificationsOptIn.enable?c=1k3awv7tp6r0h", defaultMessage: "Enable" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
